import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';

import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleJobRate } from '../../../Store/PHPSlice/JobRate';
import { selectJobRate, selectSingleJobrate } from '../../Selectors/Master/ItemSelectors';



const JobRateView = () => {
    const { Id } = useParams();
    const [departData, setDepartData] = useState([]);
    const dispatch = useDispatch();
    const jobrateData = useSelector(selectSingleJobrate);
    useEffect(() => {
        dispatch(fetchSingleJobRate(Id));
    }, [dispatch, Id]);

    useEffect(() => {
        if (jobrateData?.jobInfo?.length > 0) {
            const data = jobrateData?.jobInfo;
            setDepartData(data);
        }

    }, [jobrateData]);

    const total = jobrateData?.data?.total;
    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Job Rate View</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>

                            {departData?.length > 0 &&
                                <table>
                                    <thead>
                                        {departData?.map((dept, index) => (<th key={index}>{dept.departNm}</th>))}

                                        <th>Total</th>
                                    </thead>
                                    <tbody>
                                        {departData?.map((dept, index) => (
                                            <td key={index}>
                                                {dept.rate}
                                            </td>))}

                                        <td style={{ fontSize: '17px' }}>
                                            {total}
                                        </td>
                                    </tbody>
                                </table>
                            }


                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default JobRateView;
